import { Box, Typography } from '@mui/material';
import '@mui/material/SvgIcon';
import List from '@mui/material/List';
import { useTheme } from '@mui/material/styles';
import AppsSettingsIcon from 'assets/icons/appSettings.svg';
import BotSettingsIcon from 'assets/icons/botSettings.svg';
import ChatSettingsIcon from 'assets/icons/chatSettings.svg';
import GeneralSettingsIcon from 'assets/icons/generalSettings.svg';
import TeamSettingsIcon from 'assets/icons/teamsSettings.svg';
import SettingsItem from 'components/@home/@settings/SettingsMenu/SettingsItem';
import connector from 'components/@home/@settings/Tabs/connector';
import React, { useMemo } from 'react';
import { agenticSectionName } from 'utils/agenticSectionPath';
import { I18n } from 'utils/i18n';

const getStyles = theme => ({
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    borderRight: `1px solid ${theme.palette.secondary.extraLight}`,
    backgroundColor: theme.palette.background.paper,
    width: 250,
  },
  head: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '20px',
  },
  listRoot: {
    padding: '10px',
  },
});

const SettingsPannel = ({ authCompany }) => {
  const theme = useTheme();
  const styles = useMemo(() => getStyles(theme), [theme]);
  const sectionName = agenticSectionName(authCompany);

  const icons = useMemo(
    () => ({
      general: <GeneralSettingsIcon />,
      teams: <TeamSettingsIcon />,
      chats: <ChatSettingsIcon />,
      apps: <AppsSettingsIcon />,
      [sectionName]: <BotSettingsIcon />,
    }),
    [sectionName],
  );

  return (
    <Box component="section" sx={styles.root}>
      <Box sx={styles.head}>
        <Typography variant="h5">{I18n.t('SettingsMenu.Title')}</Typography>
      </Box>
      <List sx={styles.listRoot}>
        {Object.entries(icons).map(([name, icon], index) => (
          <SettingsItem name={name} key={name} icon={icon} index={index} />
        ))}
      </List>
    </Box>
  );
};

export default connector(SettingsPannel);
